import type { SettingsRow } from '@/types'

import { ArrowUp, Heart } from 'lucide-react'

interface SiteFooterProps {
    settings: SettingsRow | null
}

export default function SiteFooter({ settings }: SiteFooterProps) {
    return (
        <footer className='relative overflow-hidden border-t border-white/10 bg-night px-6 py-14 text-center text-cream'>
            <div className='mx-auto max-w-xl'>
                <Heart aria-hidden className='mx-auto size-6 animate-heartbeat fill-petal text-petal motion-reduce:animate-none' />

                {settings && (settings.hero_title || settings.her_name) && (
                    <p className='mt-4 font-script text-4xl text-[#ffd1dc] sm:text-5xl'>
                        {settings.hero_title && (
                            <span data-mdlfy-cms={`settings:${settings.id}:hero_title`}>
                                {settings.hero_title}
                            </span>
                        )}

                        {settings.hero_title && settings.her_name && ', '}

                        {settings.her_name && (
                            <span data-mdlfy-cms={`settings:${settings.id}:her_name`}>
                                {settings.her_name}
                            </span>
                        )}
                    </p>
                )}

                {settings?.footer_note && (
                    <p
                        data-mdlfy-cms={`settings:${settings.id}:footer_note`}
                        className='mt-3 text-sm text-cream/65'
                    >
                        {settings.footer_note}
                    </p>
                )}

                <a
                    href='#hero'
                    className='mt-8 inline-flex items-center gap-2 rounded-full bg-white/[0.08] px-5 py-2.5 text-xs font-bold tracking-[0.2em] text-cream/80 uppercase ring-1 ring-white/15 transition outline-none hover:bg-white/15 hover:text-cream focus-visible:ring-4 focus-visible:ring-[#ffd1dc]/50'
                >
                    <ArrowUp aria-hidden className='size-4' />
                    Upar chalo
                </a>
            </div>
        </footer>
    )
}
